export const SET_DEVICE_ID = 'SET_DEVICE_ID';

export const SET_SPOT_INSTANCE_INFO = 'SET_SPOT_INSTANCE_INFO';
